import { createContext, useContext } from 'react'

export const adminTranslations = {
  ar: {
    // Sidebar navigation
    dashboard: 'لوحة التحكم',
    news: 'الأخبار',
    events: 'الفعاليات',
    heritage: 'تراثنا حياة',
    partners: 'الشركاء',
    heroSlides: 'صور الواجهة',
    gallery: 'المعرض',
    siteSettings: 'إعدادات الموقع',
    messages: 'الرسائل',
    admins: 'المشرفون',
    profile: 'الملف الشخصي',
    logout: 'تسجيل الخروج',

    // Permission Templates
    permissionTemplates: 'قوالب الصلاحيات',
    selectTemplate: 'اختر القالب',
    applyTemplate: 'تطبيق القالب',
    createTemplate: 'إنشاء قالب',
    editTemplate: 'تعديل القالب',
    templateName: 'اسم القالب',
    templateDescription: 'وصف القالب',
    replaceCurrentPermissions: 'استبدال الصلاحيات الحالية',
    mergeWithCurrentPermissions: 'دمج مع الصلاحيات الحالية',
    templateApplied: 'تم تطبيق القالب',
    saveTemplate: 'حفظ القالب',
    noTemplates: 'لا توجد قوالب',
    deactivateTemplate: 'إيقاف القالب',
    workflow: 'مسار العمل',
    stepSelectAdmin: 'اختر المشرف',
    stepSelectTemplate: 'اختر قالب الصلاحيات',
    stepApplyMode: 'اختر طريقة التطبيق',
    stepCustomize: 'راجع وعدّل الصلاحيات',
    stepSave: 'احفظ الصلاحيات',
    replaceMode: 'استبدال الصلاحيات الحالية',
    mergeMode: 'دمج مع الصلاحيات الحالية',
    applyTemplateHint: 'تطبيق القالب يحدّث المصفوفة الحالية فقط. اضغط حفظ الصلاحيات لتثبيت التغييرات.',
    customizePermissions: 'تخصيص الصلاحيات',
    savePermissions: 'حفظ الصلاحيات',
    templateManagement: 'إدارة القوالب',
    templateManagementHint: 'أنشئ القوالب وعدّلها هنا بشكل مستقل عن تطبيقها على المشرفين.',
    editSelectedTemplate: 'تعديل القالب المحدد',
    editTemplateAction: 'تعديل',
    customTemplateLanguageHint: 'يُحفظ اسم ووصف القالب باللغة التي تُدخلها.',
    templateNameRequired: 'اسم القالب مطلوب',
    templateSaveSuccess: 'تم حفظ القالب بنجاح',
    templateDefaultContentEditor: 'محرر المحتوى',
    templateDefaultContentEditorDescription: 'عرض وإنشاء وتحديث الأخبار والفعاليات والتراث، مع عرض بقية الوحدات فقط.',
    templateDefaultMediaManager: 'مدير الوسائط',
    templateDefaultMediaManagerDescription: 'إدارة كاملة للمعرض، مع عرض الأخبار والفعاليات والتراث فقط.',
    templateDefaultNewsEventsManager: 'مدير الأخبار والفعاليات',
    templateDefaultNewsEventsManagerDescription: 'إدارة كاملة للأخبار والفعاليات، مع عرض المعرض فقط.',
    templateDefaultReadOnlyAdmin: 'مشرف للقراءة فقط',
    templateDefaultReadOnlyAdminDescription: 'عرض جميع الوحدات المدعومة دون إنشاء أو تحديث أو حذف.',
    noAdmins: 'لا يوجد مشرفون عاديون',
    adminPanel: 'لوحة الإدارة',
    yemenHeritage: 'منظمة تراث اليمن',
    switchLang: 'English',

    // Common actions
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    actions: 'إجراءات',
    loading: 'جارٍ التحميل...',
    saving: 'جارٍ الحفظ...',
    noData: 'لا توجد بيانات',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    success: 'نجح',
    error: 'خطأ',
    welcome: 'مرحباً',
    viewAll: 'عرض الكل',
    viewSite: 'عرض الموقع',
    quickActions: 'إجراءات سريعة',
    preview: 'معاينة',
    open: 'فتح',
    close: 'إغلاق',
    yes: 'نعم',
    no: 'لا',
    upload: 'رفع',
    change: 'تغيير',
    remove: 'إزالة',

    // Status labels
    all: 'الكل',
    active: 'نشط',
    inactive: 'معطّل',
    published: 'منشور',
    draft: 'مسودة',
    hidden: 'مخفي',
    visible: 'ظاهر',
    public: 'عام',

    // Form labels
    title: 'العنوان',
    titleAr: 'العنوان (عربي)',
    titleEn: 'العنوان (إنجليزي)',
    content: 'المحتوى',
    contentAr: 'المحتوى (عربي)',
    contentEn: 'المحتوى (إنجليزي)',
    description: 'الوصف',
    descriptionAr: 'الوصف (عربي)',
    descriptionEn: 'الوصف (إنجليزي)',
    image: 'الصورة',
    date: 'التاريخ',
    category: 'التصنيف',
    categoryAr: 'التصنيف (عربي)',
    categoryEn: 'التصنيف (إنجليزي)',
    status: 'الحالة',
    order: 'الترتيب',
    sortOrder: 'الترتيب',
    required: 'مطلوب',

    // News management
    manageNews: 'إدارة الأخبار',
    totalNews: 'إجمالي الأخبار',
    addNews: 'إضافة خبر',
    editNews: 'تعديل الخبر',
    addNewNews: 'إضافة خبر جديد',
    newsImage: 'صورة الخبر',
    searchNews: 'بحث في الأخبار...',
    noResults: 'لا توجد نتائج',
    publishedPublic: 'منشور (ظاهر للعامة)',
    titleRequired: 'العنوان مطلوب',
    saved: 'تم الحفظ',
    added: 'تم الإضافة',
    deleted: 'تم الحذف',

    // Events management
    manageEvents: 'إدارة الفعاليات',
    addEvent: 'إضافة فعالية',
    editEvent: 'تعديل الفعالية',
    noEvents: 'لا توجد فعاليات',
    eventImage: 'صورة الفعالية',
    eventType: 'النوع',
    eventDate: 'التاريخ',
    location: 'الموقع',
    locationAr: 'الموقع (عربي)',
    locationEn: 'الموقع (إنجليزي)',
    typeEvent: 'فعالية',
    typeSeminar: 'ندوة',
    typeProject: 'مشروع',
    typeTraining: 'تدريب',
    upcomingEvents: 'الفعاليات القادمة',
    notSet: 'لم يُحدد',

    // Heritage management
    manageHeritage: 'إدارة تراثنا حياة',
    addHeritage: 'إضافة عنصر',
    editHeritage: 'تعديل العنصر',
    addHeritageItem: 'إضافة عنصر تراثي',
    heritageImage: 'صورة العنصر التراثي',
    noHeritage: 'لا توجد عناصر',
    tangible: 'مادي',
    intangible: 'لامادي',
    period: 'الحقبة الزمنية',
    periodPlaceholder: 'مثال: القرن 12',
    locationPlaceholder: 'تعز، اليمن',

    // Partners management
    managePartners: 'إدارة الشركاء',
    addPartner: 'إضافة شريك',
    editPartner: 'تعديل الشريك',
    noPartners: 'لا يوجد شركاء',
    partnerLogo: 'شعار الشريك',
    partnerName: 'الاسم',
    partnerNameAr: 'الاسم (عربي)',
    partnerNameEn: 'الاسم (إنجليزي)',
    websiteUrl: 'رابط الموقع (اختياري)',
    activePublic: 'نشط (ظاهر للعامة)',

    // Gallery management
    manageGallery: 'إدارة المعرض',
    manageFields: 'مجالات العمل',
    addGallery: 'إضافة عنصر',
    addGalleryItem: 'إضافة عنصر للمعرض',
    editGallery: 'تعديل عنصر المعرض',
    editGalleryItem: 'تعديل عنصر المعرض',
    galleryItems: 'عناصر المعرض',
    noGallery: 'لا توجد عناصر في المعرض',
    noGalleryItems: 'لا توجد عناصر في المعرض',
    galleryImage: 'صورة المعرض',
    galleryThumbnail: 'الصورة المصغرة',
    galleryType: 'نوع العنصر',
    itemType: 'نوع العنصر',
    typePhoto: 'صورة',
    typeVideo: 'فيديو',
    photo: 'صورة',
    photos: 'الصور',
    video: 'فيديو',
    videos: 'الفيديو',
    videoUrl: 'رابط الفيديو',
    videoThumbnail: 'صورة مصغرة للفيديو',
    thumbnailUrl: 'رابط الصورة المصغرة',
    imageUrl: 'رابط الصورة',
    showOnWebsite: 'إظهار في الموقع',
    activeGalleryItem: 'نشط (ظاهر للعامة)',
    searchGallery: 'بحث في المعرض...',
    galleryTitleRequired: 'عنوان العنصر مطلوب',
    galleryImageRequired: 'صورة المعرض مطلوبة',
    videoUrlRequired: 'رابط الفيديو مطلوب',
    gallerySaved: 'تم حفظ عنصر المعرض',
    galleryDeleted: 'تم حذف عنصر المعرض',
    deleteGalleryItem: 'حذف هذا العنصر من المعرض؟',
    totalGallery: 'إجمالي عناصر المعرض',
    totalPhotos: 'إجمالي الصور',
    totalVideos: 'إجمالي الفيديوهات',
    selectGallery: 'اختيار ألبومات المعرض',
    createGallery: 'إنشاء ألبوم جديد',
    noGallery: 'لا يوجد ألبومات',
    galleryCreated: 'تم إنشاء الألبوم بنجاح',
    chooseMedia: 'اختر الوسائط',

    // Hero slides management
    manageHero: 'إدارة صور الواجهة',
    addSlide: 'إضافة صورة',
    editSlide: 'تعديل الصورة',
    noSlides: 'لا توجد صور',
    heroImage: 'صورة الواجهة',
    caption: 'الوصف',
    captionAr: 'التسمية (عربي)',
    captionEn: 'التسمية (إنجليزي)',
    altAr: 'نص بديل (عربي)',
    altEn: 'نص بديل (إنجليزي)',
    imageRequired: 'الصورة مطلوبة',

    // Site settings
    manageSiteSettings: 'إعدادات الموقع',
    contactInfo: 'بيانات التواصل',
    phone: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    addressAr: 'العنوان (عربي)',
    addressEn: 'العنوان (إنجليزي)',
    socialLinks: 'روابط التواصل الاجتماعي',
    footerText: 'نص التذييل',
    footerDescAr: 'الوصف (عربي)',
    footerDescEn: 'الوصف (إنجليزي)',
    homeAboutImage: 'صورة قسم "من نحن" في الرئيسية',
    saveSettings: 'حفظ الإعدادات',
    settingsSaved: 'تم حفظ الإعدادات',

    // Messages management
    manageMessages: 'رسائل التواصل',
    unreadMessages: 'رسالة غير مقروءة',
    noMessages: 'لا توجد رسائل',
    selectMessage: 'اختر رسالة لعرضها',
    subject: 'الموضوع',
    message: 'الرسالة',
    reply: 'الرد',
    deleteMessage: 'حذف هذه الرسالة؟',

    // Admins management
    manageAdmins: 'إدارة المشرفين',
    addAdmin: 'إضافة مشرف',
    addNewAdmin: 'إضافة مشرف جديد',
    editAdmin: 'تعديل المشرف',
    name: 'الاسم',
    fullName: 'الاسم الكامل',
    password: 'كلمة المرور',
    emailRequired: 'البريد وكلمة المرور مطلوبان',
    passwordTooShort: 'كلمة المرور قصيرة جداً',
    changePassword: 'تغيير كلمة المرور',
    newPassword: 'كلمة المرور الجديدة',
    activeAccount: 'حساب نشط',
    lastLogin: 'آخر دخول',
    neverLoggedIn: 'لم يدخل بعد',
    you: 'أنت',
    cannotDeleteSelf: 'لا يمكنك حذف حسابك الخاص',
    minChars: '6 أحرف على الأقل',
    
    // Admin Details
    adminDetails: 'تفاصيل المشرف',
    contentStatistics: 'إحصائيات المحتوى',
    recentActivity: 'أحدث النشاطات',
    permissionsSummary: 'ملخص الصلاحيات',
    viewDetails: 'عرض التفاصيل',
    itemsCreated: 'تم الإنشاء',
    itemsUpdated: 'تم التحديث',
    managePermissions: 'إدارة الصلاحيات',
    noRecentActivity: 'لا يوجد نشاط أخير',
    
    // Activity Actions
    actionCreate: 'إنشاء',
    actionUpdate: 'تعديل',
    actionDelete: 'حذف',
    actionLogin: 'تسجيل دخول',
    actionPublish: 'نشر',
    actionUnpublish: 'إلغاء النشر',
    
    // Activity Entities
    entityNews: 'خبر',
    entityEvent: 'فعالية',
    entityHeritage_item: 'عنصر تراثي',
    entityGallery_collection: 'ألبوم المعرض',
    entityGallery_item: 'عنصر المعرض',
    entityWork_field: 'مجال عمل',
    entityHero_slide: 'شرائح الواجهة',
    entityPartner: 'شريك',
    entityAdmin_password: 'كلمة مرور المشرف',

    // Role
    role: 'الدور',
    superAdmin: 'مشرف رئيسي',
    regularAdmin: 'مشرف',

    // New password min
    min8Chars: '8 أحرف على الأقل',

    // Hero CTA
    ctaLink: 'رابط الزر (CTA)',
    ctaSection: 'زر الاستجابة (اختياري)',
    ctaTextAr: 'نص الزر (عربي)',
    ctaTextEn: 'نص الزر (إنجليزي)',

    // Profile
    myProfile: 'الملف الشخصي',
    accountInfo: 'معلومات الحساب',
    createdAt: 'تاريخ الإنشاء',
    currentPassword: 'كلمة المرور الحالية',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordsNotMatch: 'كلمتا المرور غير متطابقتين',
    passwordShort: 'كلمة المرور قصيرة',
    nameUpdated: 'تم تحديث الاسم',
    passwordChanged: 'تم تغيير كلمة المرور',
    changingPassword: 'جارٍ التغيير...',

    // Dashboard
    dashboardTitle: 'لوحة التحكم',
    dashboardSubtitle: 'إدارة موقع منظمة تراث اليمن لأجل السلام',
    latestNews: 'آخر الأخبار',
    noNews: 'لا توجد أخبار',
    heritageLife: 'تراث حياة',

    // Activity Log / Monitoring
    activityLog: 'سجل النشاطات',
    systemOverview: 'نظرة عامة على النظام',
    recentActivity: 'أحدث النشاطات',
    contentSummary: 'ملخص المحتوى',
    adminWorkload: 'نشاط المشرفين',
    activityTimeline: 'سجل النشاطات',
    totalActivities: 'إجمالي النشاطات',
    activeAdmins: 'المشرفين النشطين',
    dateRange: 'نطاق التاريخ',
    applyFilter: 'تطبيق',
    resetFilter: 'إعادة ضبط',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    actionType: 'نوع الإجراء',
    contentType: 'نوع المحتوى',
    entityType: 'نوع المحتوى',
    adminName: 'اسم المشرف',
    actionCreate: 'إنشاء',
    actionUpdate: 'تحديث',
    actionDelete: 'حذف',
    actionPublish: 'نشر',
    actionUnpublish: 'إلغاء النشر',
    actionActivate: 'تفعيل',
    actionDeactivate: 'تعطيل',
    beforeData: 'البيانات السابقة',
    afterData: 'البيانات الحالية',
    createdContentCount: 'المحتوى المضاف',
    updatedContentCount: 'المحتوى المحدث',
    latestCreated: 'أحدث إضافة',
    latestUpdated: 'أحدث تعديل',
    totalActivities: 'إجمالي النشاطات',
    viewDetails: 'عرض التفاصيل',
    noActivities: 'لم يتم العثور على أي نشاطات',
    searchActivity: 'بحث في النشاطات...',
    adminFilter: 'كل المشرفين',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    exportCSV: 'تصدير CSV',
    clearFilters: 'مسح الفلاتر',
    downloadStarted: 'بدأ التحميل...',
    beforeChange: 'قبل التغيير',
    afterChange: 'بعد التغيير',

    // Accountability
    contentAccountability: 'مسؤولية المحتوى',
    createdBy: 'أنشأ بواسطة',
    lastUpdatedBy: 'آخر تعديل بواسطة',
    responsibleAdmin: 'المسؤول',
    createdDate: 'تاريخ الإنشاء',
    updatedDate: 'تاريخ التحديث',
    unknownAdmin: 'غير معروف',
    notAssigned: 'غير معين',

    // Permissions
    permissions: 'الصلاحيات',
    managePermissions: 'إدارة الصلاحيات',
    adminPermissions: 'صلاحيات المشرف',
    module: 'الوحدة',
    view: 'عرض',
    create: 'إنشاء',
    update: 'تحديث',
    deletePermission: 'حذف', // To avoid clash with existing 'delete' if any, but since it's flat we'll just use these. Wait, 'delete' exists as 'حذف', 'save' as 'حفظ'. I can just reuse them if they exist, but the prompt says:
    // Add Arabic and English translations: Permissions, Manage Permissions, Admin Permissions, View, Create, Update, Delete, Save, Saved successfully, Permission updated, Select administrator, No administrator selected
    permissionUpdated: 'تم تحديث الصلاحية',
    selectAdministrator: 'اختر المشرف',
    noAdministratorSelected: 'لم يتم اختيار أي مشرف',
  },

  en: {
    // Sidebar navigation
    dashboard: 'Dashboard',
    news: 'News',
    events: 'Events',
    heritage: 'Heritage Life',
    partners: 'Partners',
    heroSlides: 'Hero Slides',
    gallery: 'Gallery',
    siteSettings: 'Site Settings',
    messages: 'Messages',
    admins: 'Administrators',
    profile: 'Profile',
    logout: 'Logout',

    // Permission Templates
    permissionTemplates: 'Permission Templates',
    selectTemplate: 'Select Template',
    applyTemplate: 'Apply Template',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    templateName: 'Template Name',
    templateDescription: 'Template Description',
    replaceCurrentPermissions: 'Replace Current Permissions',
    mergeWithCurrentPermissions: 'Merge With Current Permissions',
    templateApplied: 'Template Applied',
    saveTemplate: 'Save Template',
    noTemplates: 'No Templates',
    deactivateTemplate: 'Deactivate Template',
    workflow: 'Workflow',
    stepSelectAdmin: 'Select administrator',
    stepSelectTemplate: 'Select permission template',
    stepApplyMode: 'Choose apply mode',
    stepCustomize: 'Review and customize permissions',
    stepSave: 'Save permissions',
    replaceMode: 'Replace current permissions',
    mergeMode: 'Merge with current permissions',
    applyTemplateHint: 'Applying a template updates the matrix only. Select Save Permissions to persist the changes.',
    customizePermissions: 'Customize permissions',
    savePermissions: 'Save permissions',
    templateManagement: 'Template management',
    templateManagementHint: 'Create and edit templates here, separately from applying them to administrators.',
    editSelectedTemplate: 'Edit selected template',
    editTemplateAction: 'Edit',
    customTemplateLanguageHint: 'The template name and description are saved in the language entered.',
    templateNameRequired: 'Template name is required',
    templateSaveSuccess: 'Template saved successfully',
    templateDefaultContentEditor: 'Content Editor',
    templateDefaultContentEditorDescription: 'View, create, and update News, Events, and Heritage; view other modules only.',
    templateDefaultMediaManager: 'Media Manager',
    templateDefaultMediaManagerDescription: 'Full Gallery management; view News, Events, and Heritage only.',
    templateDefaultNewsEventsManager: 'News & Events Manager',
    templateDefaultNewsEventsManagerDescription: 'Full News and Events management; view Gallery only.',
    templateDefaultReadOnlyAdmin: 'Read Only Admin',
    templateDefaultReadOnlyAdminDescription: 'View all supported modules without creating, updating, or deleting.',
    noAdmins: 'No regular administrators found',
    adminPanel: 'Admin Panel',
    yemenHeritage: 'Yemen Heritage Organization',
    switchLang: 'عربي',

    // Common actions
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    loading: 'Loading...',
    saving: 'Saving...',
    noData: 'No data available',
    confirmDelete: 'Are you sure you want to delete?',
    success: 'Success',
    error: 'Error',
    welcome: 'Welcome',
    viewAll: 'View All',
    viewSite: 'View Site',
    quickActions: 'Quick Actions',
    preview: 'Preview',
    open: 'Open',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    upload: 'Upload',
    change: 'Change',
    remove: 'Remove',

    // Status labels
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    published: 'Published',
    draft: 'Draft',
    hidden: 'Hidden',
    visible: 'Visible',
    public: 'Public',

    // Form labels
    title: 'Title',
    titleAr: 'Title (Arabic)',
    titleEn: 'Title (English)',
    content: 'Content',
    contentAr: 'Content (Arabic)',
    contentEn: 'Content (English)',
    description: 'Description',
    descriptionAr: 'Description (Arabic)',
    descriptionEn: 'Description (English)',
    image: 'Image',
    date: 'Date',
    category: 'Category',
    categoryAr: 'Category (Arabic)',
    categoryEn: 'Category (English)',
    status: 'Status',
    order: 'Order',
    sortOrder: 'Order',
    required: 'Required',

    // News management
    manageNews: 'Manage News',
    totalNews: 'Total News',
    addNews: 'Add News',
    editNews: 'Edit News',
    addNewNews: 'Add New News',
    newsImage: 'News Image',
    searchNews: 'Search news...',
    noResults: 'No results',
    publishedPublic: 'Published (visible to public)',
    titleRequired: 'Title is required',
    saved: 'Saved',
    added: 'Added',
    deleted: 'Deleted',

    // Events management
    manageEvents: 'Manage Events',
    addEvent: 'Add Event',
    editEvent: 'Edit Event',
    noEvents: 'No events',
    eventImage: 'Event Image',
    eventType: 'Type',
    eventDate: 'Date',
    location: 'Location',
    locationAr: 'Location (Arabic)',
    locationEn: 'Location (English)',
    typeEvent: 'Event',
    typeSeminar: 'Seminar',
    typeProject: 'Project',
    typeTraining: 'Training',
    upcomingEvents: 'Upcoming Events',
    notSet: 'Not set',

    // Heritage management
    manageHeritage: 'Manage Heritage Life',
    addHeritage: 'Add Item',
    editHeritage: 'Edit Item',
    addHeritageItem: 'Add Heritage Item',
    heritageImage: 'Heritage Item Image',
    noHeritage: 'No items',
    tangible: 'Tangible',
    intangible: 'Intangible',
    period: 'Time Period',
    periodPlaceholder: 'Example: 12th Century',
    locationPlaceholder: 'Taiz, Yemen',

    // Partners management
    managePartners: 'Manage Partners',
    addPartner: 'Add Partner',
    editPartner: 'Edit Partner',
    noPartners: 'No partners',
    partnerLogo: 'Partner Logo',
    partnerName: 'Name',
    partnerNameAr: 'Name (Arabic)',
    partnerNameEn: 'Name (English)',
    websiteUrl: 'Website URL (optional)',
    activePublic: 'Active (visible to public)',

    // Gallery management
    manageGallery: 'Manage Gallery',
    manageFields: 'Manage Fields',
    addGallery: 'Add Item',
    addGalleryItem: 'Add Gallery Item',
    editGallery: 'Edit Gallery Item',
    editGalleryItem: 'Edit Gallery Item',
    galleryItems: 'Gallery Items',
    noGallery: 'No gallery items',
    noGalleryItems: 'No gallery items',
    galleryImage: 'Gallery Image',
    galleryThumbnail: 'Thumbnail',
    galleryType: 'Item Type',
    itemType: 'Item Type',
    typePhoto: 'Photo',
    typeVideo: 'Video',
    photo: 'Photo',
    photos: 'Photos',
    video: 'Video',
    videos: 'Videos',
    videoUrl: 'Video URL',
    videoThumbnail: 'Video Thumbnail',
    thumbnailUrl: 'Thumbnail URL',
    imageUrl: 'Image URL',
    showOnWebsite: 'Show on website',
    activeGalleryItem: 'Active (visible to public)',
    searchGallery: 'Search gallery...',
    galleryTitleRequired: 'Gallery item title is required',
    galleryImageRequired: 'Gallery image is required',
    videoUrlRequired: 'Video URL is required',
    gallerySaved: 'Gallery item saved',
    galleryDeleted: 'Gallery item deleted',
    deleteGalleryItem: 'Delete this gallery item?',
    totalGallery: 'Total Gallery Items',
    totalPhotos: 'Total Photos',
    totalVideos: 'Total Videos',
    selectGallery: 'Select Gallery Collections',
    createGallery: 'Create New Gallery',
    noGallery: 'No galleries found',
    galleryCreated: 'Gallery created successfully',
    chooseMedia: 'Choose Media',

    // Hero slides management
    manageHero: 'Manage Hero Slides',
    addSlide: 'Add Slide',
    editSlide: 'Edit Slide',
    noSlides: 'No slides',
    heroImage: 'Hero Image',
    caption: 'Caption',
    captionAr: 'Caption (Arabic)',
    captionEn: 'Caption (English)',
    altAr: 'Alt Text (Arabic)',
    altEn: 'Alt Text (English)',
    imageRequired: 'Image is required',

    // Site settings
    manageSiteSettings: 'Site Settings',
    contactInfo: 'Contact Information',
    phone: 'Phone Number',
    email: 'Email',
    addressAr: 'Address (Arabic)',
    addressEn: 'Address (English)',
    socialLinks: 'Social Media Links',
    footerText: 'Footer Text',
    footerDescAr: 'Description (Arabic)',
    footerDescEn: 'Description (English)',
    homeAboutImage: '"About Us" Section Image on Home',
    saveSettings: 'Save Settings',
    settingsSaved: 'Settings saved',

    // Messages management
    manageMessages: 'Contact Messages',
    unreadMessages: 'unread message(s)',
    noMessages: 'No messages',
    selectMessage: 'Select a message to view',
    subject: 'Subject',
    message: 'Message',
    reply: 'Reply',
    deleteMessage: 'Delete this message?',

    // Admins management
    manageAdmins: 'Manage Administrators',
    addAdmin: 'Add Admin',
    addNewAdmin: 'Add New Administrator',
    editAdmin: 'Edit Administrator',
    name: 'Name',
    fullName: 'Full Name',
    password: 'Password',
    emailRequired: 'Email and password are required',
    passwordTooShort: 'Password is too short',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    activeAccount: 'Active Account',
    lastLogin: 'Last Login',
    neverLoggedIn: 'Never logged in',
    you: 'You',
    cannotDeleteSelf: 'You cannot delete your own account',
    minChars: 'Minimum 6 characters',
    
    // Admin Details
    adminDetails: 'Admin Details',
    contentStatistics: 'Content Statistics',
    recentActivity: 'Recent Activity',
    permissionsSummary: 'Permissions Summary',
    viewDetails: 'View Details',
    itemsCreated: 'Created',
    itemsUpdated: 'Updated',
    managePermissions: 'Manage Permissions',
    noRecentActivity: 'No recent activity',
    
    // Activity Actions
    actionCreate: 'Create',
    actionUpdate: 'Update',
    actionDelete: 'Delete',
    actionLogin: 'Login',
    actionPublish: 'Publish',
    actionUnpublish: 'Unpublish',
    
    // Activity Entities
    entityNews: 'News',
    entityEvent: 'Event',
    entityHeritage_item: 'Heritage Item',
    entityGallery_collection: 'Gallery Collection',
    entityGallery_item: 'Gallery Item',
    entityWork_field: 'Work Field',
    entityHero_slide: 'Hero Slide',
    entityPartner: 'Partner',
    entityAdmin_password: 'Admin Password',

    // Role
    role: 'Role',
    superAdmin: 'Super Admin',
    regularAdmin: 'Admin',

    // New password min
    min8Chars: 'Minimum 8 characters',

    // Hero CTA
    ctaLink: 'CTA Button Link',
    ctaSection: 'Call-To-Action (optional)',
    ctaTextAr: 'Button Label (Arabic)',
    ctaTextEn: 'Button Label (English)',

    // Profile
    myProfile: 'My Profile',
    accountInfo: 'Account Information',
    createdAt: 'Created At',
    currentPassword: 'Current Password',
    confirmPassword: 'Confirm Password',
    passwordsNotMatch: 'Passwords do not match',
    passwordShort: 'Password is too short',
    nameUpdated: 'Name updated',
    passwordChanged: 'Password changed',
    changingPassword: 'Changing...',

    // Dashboard
    dashboardTitle: 'Dashboard',
    dashboardSubtitle: 'Manage Yemen Heritage for Peace Organization Website',
    latestNews: 'Latest News',
    noNews: 'No news',
    heritageLife: 'Heritage Life',

    // Activity Log / Monitoring
    activityLog: 'Activity Log',
    systemOverview: 'System Overview',
    recentActivity: 'Recent Activity',
    contentSummary: 'Content Summary',
    adminWorkload: 'Admin Workload',
    activityTimeline: 'Activity Timeline',
    totalActivities: 'Total Activities',
    activeAdmins: 'Active Admins',
    dateRange: 'Date Range',
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    dateFrom: 'From Date',
    dateTo: 'To Date',
    actionType: 'Action',
    contentType: 'Content Type',
    entityType: 'Content Type',
    adminName: 'Admin Name',
    actionCreate: 'Create',
    actionUpdate: 'Update',
    actionDelete: 'Delete',
    actionPublish: 'Publish',
    actionUnpublish: 'Unpublish',
    actionActivate: 'Activate',
    actionDeactivate: 'Deactivate',
    beforeData: 'Before Data',
    afterData: 'After Data',
    createdContentCount: 'Created Content',
    updatedContentCount: 'Updated Content',
    latestCreated: 'Latest Created',
    latestUpdated: 'Latest Updated',
    totalActivities: 'Total Activities',
    viewDetails: 'View Details',
    noActivities: 'No activities found',
    searchActivity: 'Search activities...',
    adminFilter: 'All admins',
    dateFrom: 'From date',
    dateTo: 'To date',
    exportCSV: 'Export CSV',
    clearFilters: 'Clear Filters',
    downloadStarted: 'Download started...',
    beforeChange: 'Before Change',
    afterChange: 'After Change',

    // Accountability
    contentAccountability: 'Content Accountability',
    createdBy: 'Created by',
    lastUpdatedBy: 'Last updated by',
    responsibleAdmin: 'Responsible admin',
    createdDate: 'Created date',
    updatedDate: 'Updated date',
    unknownAdmin: 'Unknown',
    notAssigned: 'Not assigned',

    // Permissions
    permissions: 'Permissions',
    managePermissions: 'Manage Permissions',
    adminPermissions: 'Admin Permissions',
    module: 'Module',
    view: 'View',
    create: 'Create',
    update: 'Update',
    deletePermission: 'Delete',
    permissionUpdated: 'Permission updated',
    selectAdministrator: 'Select administrator',
    noAdministratorSelected: 'No administrator selected',
  },
}

// Create context for admin language
export const AdminLangContext = createContext(null)

export const useAdminLang = () => {
  const context = useContext(AdminLangContext)

  if (!context) {
    throw new Error('useAdminLang must be used within AdminLangProvider')
  }

  return context
}
